import { M8TariffPart } from 'services/production/types';
import { ClientProductCalculation } from 'types/clientProductTypes';
import { createClientProductCalculation } from 'utils/clientProductUtils';

export const normalizeM8TariffParts = (m8TariffParts: M8TariffPart[]) => ({
  toClientProductCalculation(): ClientProductCalculation {
    return m8TariffParts.reduce((acc, m8TariffPart) => {
      const { tarifPartType, tarifValue, percentOfPart } = m8TariffPart;

      if (tarifPartType === 'AGM_PART') {
        acc.agmAmount = tarifValue;
        acc.agmPercent = percentOfPart;
      }

      if (tarifPartType === 'COMISSION') {
        acc.partnerAmount = tarifValue;
        acc.partnerPercent = percentOfPart;
      }

      if (tarifPartType === 'DISCOUNT') {
        acc.discountAmount = tarifValue;
        acc.discountPercent = percentOfPart;
      }

      if (tarifPartType === 'AGM_PART' || tarifPartType === 'COMISSION') {
        acc.tariffAmount = acc.tariffAmount + tarifValue;
      }

      return acc;
    }, createClientProductCalculation());
  },
});
